import getDefaultShouldShortenEventDurationEndEarly from './getDefaultShouldShortenEventDurationEndEarly';
import getDefaultShouldShortenEventDurationStartLate from './getDefaultShouldShortenEventDurationStartLate';

/**
 * Gets whether the event duration should be shorten or not
 */
export default function getDefaultShouldShortenEventDuration(): boolean {
    return (
        getDefaultShouldShortenEventDurationStartLate() ||
        getDefaultShouldShortenEventDurationEndEarly()
    );
}
